import React from 'react';

type BadgeVariant = 'mastered' | 'in-progress' | 'locked' | 'at-risk' | 'pending' | 'certified' | 'enrolled';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
  size?: 'sm' | 'md';
}

const variantStyles: Record<BadgeVariant, string> = {
  mastered: 'bg-green-50 text-green-700 border border-green-200',
  'in-progress': 'bg-amber-50 text-amber-700 border border-amber-200',
  locked: 'bg-gray-100 text-gray-500 border border-gray-200',
  'at-risk': 'bg-red-50 text-red-600 border border-red-200',
  pending: 'bg-blue-50 text-blue-600 border border-blue-200',
  certified: 'bg-purple-50 text-purple-700 border border-purple-200',
  enrolled: 'bg-teal-50 text-teal-700 border border-teal-200',
};

export default function StatusBadge({ variant, label, size = 'sm' }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full font-500 ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'
      } ${variantStyles[variant]}`}
    >
      {label}
    </span>
  );
}